import { getTooltips } from "@redux/options/reducer";
import { useSelector } from "react-redux";

export const useTooltips = () => {
    const tooltips = useSelector(getTooltips); 
    return tooltips;
}
